export class LogEntryModel {
    public entry: string;
    public methodName: string;
    public type: string;
    public username: string = '';
    public userid: number = 0;
}
